{
  "version": "1.0.0",
  "metadata": {
    "lastUpdated": "2025-11-13T11:23:56.966Z",
    "totalSources": 1,
    "maintainer": "JoyBoy Community",
    "url": "https://github.com/Alaric-senpai/The-joyboy-project",
    "description": "Official JoyBoy source registry - Cross-platform manga parser sources",
    "license": "MIT"
  },
  "sources": [],
  "categories": {
    "official": [
      "mangadex"
    ],
    "community": [],
    "api": [
      "mangadex"
    ],
    "scraper": [
    ],
    "multi-language": [],
    "english-only": [],
    "nsfw": [],
    "sfw": []
  },
  "featured": [],
  "deprecated": [],
  "notices": []
}
